const ORDER_TAB_WAIT_PAYMENT = 0;
const ORDER_TAB_WAIT_CONFIRM = 1;
const ORDER_TAB_WAIT_DELIVER = 1;
const ORDER_TAB_PROCESSING = 1;
const ORDER_TAB_DELIVERED = 2;
const ORDER_TAB_CANCELED = 2;
const ORDER_TAB_DONE = 2;
const ORDER_STATE_DELIVERED = 'DELIVERED';
const ORDER_CUSTOMER_STATE_WAITING_DELIVERY = 1;
const ORDER_CUSTOMER_STATE_DELIVERING = 2;
const STAFF_ORDER_STATUS_CREATED = 'CREATED';
const STAFF_ORDER_STATUS_WAITING_FOR_PAYMENT_CONFIRMATION = 'WAITING_FOR_PAYMENT_CONFIRMATION';
const STAFF_ORDER_STATUS_PENDING = 'PENDING';
const STAFF_ORDER_STATUS_PAYMENT_CONFIRMED = 'PAYMENT_CONFIRMED';
const STAFF_ORDER_STATUS_CANCELLED_DRAFT = 'CANCELLED_DRAFT';
const STAFF_ORDER_STATUS_DELIVERED = 'DELIVERED';
const STAFF_ORDER_STATUS_WAIT_FOR_PROCESS = 'WAIT_FOR_PROCESS';
const STAFF_ORDER_STATUS_PROCESSING = 'PROCESSING';
const STAFF_ORDER_STATUS_CANCELLED = 'CANCELLED';
const STAFF_ORDER_STATUS_RETURNED = 'RETURNED';
const STAFF_ORDER_STATUS_NEED_REFUND = 'NEED-REFUND';
const STAFF_ORDER_STATUS_REFUND = 'REFUND';
const STAFF_ORDER_STATUSES = [
    STAFF_ORDER_STATUS_CREATED,
    STAFF_ORDER_STATUS_WAITING_FOR_PAYMENT_CONFIRMATION,
    STAFF_ORDER_STATUS_PENDING,
    STAFF_ORDER_STATUS_PAYMENT_CONFIRMED,
    STAFF_ORDER_STATUS_CANCELLED_DRAFT,
    STAFF_ORDER_STATUS_DELIVERED,
    STAFF_ORDER_STATUS_WAIT_FOR_PROCESS,
    STAFF_ORDER_STATUS_PROCESSING,
    STAFF_ORDER_STATUS_CANCELLED,
    STAFF_ORDER_STATUS_RETURNED,
    STAFF_ORDER_STATUS_NEED_REFUND,
    STAFF_ORDER_STATUS_REFUND,
];
const STAFF_ORDER_STATES = {
    new: 'Đơn mới tạo',
    active: 'Chờ thanh toán',
    paid: 'Đã thanh toán',
    processing: 'Đang xử lý',
    cancelled: 'Đã hủy',
    delivered: 'Đã giao hàng',
    returned: 'Đã trả hàng',
    reverted: 'Đã trả hàng',
    refund: 'Đã hoàn tiền',
};
const STATUS_COLOR = {
    waiting: '',
    processing: '#f78212',
    success: '#53c305',
    canceled: '#d60f29',
};
const CONSUMER_ORDER_STATUSES = [
    {
        status: 'DRAFT',
        text: null,
        displayStatus: null,
        tab: null,
        color: '',
    },
    {
        status: 'WAITING_FOR_APPROVAL',
        text: 'Chờ duyệt',
        displayStatus: 'Chờ duyệt',
        tab: null,
        color: '',
    },
    {
        status: 'CREATED',
        text: null,
        displayStatus: null,
        tab: null,
        color: '',
    },
    {
        status: 'PENDING',
        text: 'Chờ xác nhận',
        displayStatus: 'Chờ xác nhận',
        tab: ORDER_TAB_WAIT_PAYMENT,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PROCESSING',
        text: 'Đang xử lý',
        displayStatus: 'Đang xử lý',
        tab: ORDER_TAB_PROCESSING,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAITING_FOR_PAYMENT_CONFIRMATION',
        text: 'Chờ thanh toán',
        displayStatus: 'Chờ thanh toán',
        tab: ORDER_TAB_WAIT_PAYMENT,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PAYMENT_CONFIRMED',
        text: 'Đã thanh toán',
        displayStatus: 'Đã thanh toán',
        tab: ORDER_TAB_PROCESSING,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'CANCELLED',
        text: 'Đã hủy',
        displayStatus: 'Đã hủy',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'REVERTED',
        text: 'Đã trả hàng',
        displayStatus: 'Đã trả hàng',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'RETURNED',
        text: 'Trả hàng',
        displayStatus: 'Đã trả hàng',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'REFUND',
        text: 'Trả hàng',
        displayStatus: 'Đã trả hàng',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'NEED_REFUND',
        text: 'Trả hàng',
        displayStatus: 'Đã trả hàng',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'DELIVERING',
        text: 'Đang giao hàng',
        displayStatus: 'Đang giao hàng',
        tab: ORDER_TAB_PROCESSING,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'DELIVERED',
        text: 'Hoàn thành',
        displayStatus: 'Hoàn thành',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.success,
    },
];
const ORDER_SHIPMENT_STATUS = [
    {
        status: 'NEW',
        displayStatus: 'Mới',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAITING_FOR_MANUAL_CONFIRMATION',
        displayStatus: 'Chờ xác nhận',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PROVIDER_TRANSFERRING',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PROVIDER_TRANSFERRED',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAIT_FOR_PRODUCT',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAITING_FOR_PRODUCT',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PICKED',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PACKED',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'DELIVERING',
        displayStatus: 'Đang giao',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'DELIVERED',
        displayStatus: 'Đã giao',
        color: STATUS_COLOR.success,
    },
    {
        status: 'PARTIAL_DELIVERED',
        displayStatus: 'Đang giao',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'RETURNED',
        displayStatus: 'Đã trả hàng',
        color: STATUS_COLOR.success,
    },
    {
        status: 'CANCELLED',
        displayStatus: 'Đã hủy',
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'PROCESSING',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'DELIVERED_AT_AGENCY',
        displayStatus: 'Đã giao đại lý',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAITING_FOR_WAREHOUSE_CONFIRMATION',
        displayStatus: 'Chờ xác nhận',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAITING_FOR_BACKORDER_CONFIRMATION',
        displayStatus: 'Chờ xác nhận',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'BACKORDERING',
        displayStatus: 'Chờ hàng về',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'BACKORDER_INSUFFICIENT_STOCK',
        displayStatus: 'Chờ hàng về',
        color: STATUS_COLOR.processing,
    },
];
const orderStatus = {
    WAITING_FOR_MANUAL_CONFIRMATION: 'WAITING_FOR_MANUAL_CONFIRMATION',
    WAIT_FOR_PROCESS: 'WAIT_FOR_PROCESS',
    PROCESSING: 'PROCESSING',
    DELIVERED: 'DELIVERED',
    PAYMENT_CONFIRMED: 'PAYMENT_CONFIRMED',
    PAID: 'PAID',
    PENDING: 'PENDING',
    WAITING_FOR_PAYMENT_CONFIRMATION: 'WAITING_FOR_PAYMENT_CONFIRMATION',
    CANCELLED: 'CANCELLED',
    REVERTED: 'REVERTED',
    RETURNED: 'RETURNED',
    CONFIRMED: 'CONFIRMED',
    WAITING_FOR_PICKING: 'WAITING_FOR_PICKING',
    PACKED: 'PACKED',
    DELIVERING: 'DELIVERING',
    READY_FOR_PICKUP: 'READY_FOR_PICKUP',
    REFUND: 'REFUND',
};

export { CONSUMER_ORDER_STATUSES, ORDER_CUSTOMER_STATE_DELIVERING, ORDER_CUSTOMER_STATE_WAITING_DELIVERY, ORDER_SHIPMENT_STATUS, ORDER_STATE_DELIVERED, ORDER_TAB_CANCELED, ORDER_TAB_DELIVERED, ORDER_TAB_DONE, ORDER_TAB_PROCESSING, ORDER_TAB_WAIT_CONFIRM, ORDER_TAB_WAIT_DELIVER, ORDER_TAB_WAIT_PAYMENT, STAFF_ORDER_STATES, STAFF_ORDER_STATUSES, STAFF_ORDER_STATUS_CANCELLED, STAFF_ORDER_STATUS_CANCELLED_DRAFT, STAFF_ORDER_STATUS_CREATED, STAFF_ORDER_STATUS_DELIVERED, STAFF_ORDER_STATUS_NEED_REFUND, STAFF_ORDER_STATUS_PAYMENT_CONFIRMED, STAFF_ORDER_STATUS_PENDING, STAFF_ORDER_STATUS_PROCESSING, STAFF_ORDER_STATUS_REFUND, STAFF_ORDER_STATUS_RETURNED, STAFF_ORDER_STATUS_WAITING_FOR_PAYMENT_CONFIRMATION, STAFF_ORDER_STATUS_WAIT_FOR_PROCESS, STATUS_COLOR, orderStatus };
